export const SUBJECT_TYPES = {
  doctor: 'doctor',
  lpu: 'lpu',
}
